export const REGISTRATION_NOT_ALLOWED = {
    NONE: 0,
    NOT_A_MEMBER: 1,
    NOT_A_CLUB_MEMBER: 2,
    GUEST_ACCOUNT: 4,
    DIRECTOR: 8,
    OUTSIDE_LEVEL: 16,
    REGISTRATION_CLOSED: 32,
    ALREADY_PARTICIPANT: 64,
    OTHER: 1024,
} as const;